import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Project PI: The association(s) between principal investigator (PI) and a project. A PI may oversee multiple projects or share a project with other PIs.',
    name: 'Project PIs',
    partialId: PartialId.Standard.create('proj_pis'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
